import { Link } from 'react-router-dom';
import { servicePackages } from '@/mocks/services';

export default function ServicesOverview() {
  return (
    <section id="leistungen" className="bg-offwhite py-20 md:py-28 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="font-sans text-xs tracking-widest uppercase text-rose font-semibold">
            Unsere Anwendungen
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-medium text-charcoal mt-3 mb-4">
            Finde dein perfektes Lächeln
          </h2>
          <p className="font-sans text-base text-charcoal/60 max-w-xl mx-auto leading-relaxed">
            Jede Anwendung ist individuell auf dich abgestimmt — peroxidfrei, schmerzlos und professionell.
          </p>
        </div>

        {/* Cards */}
        <div className="flex flex-col sm:grid sm:grid-cols-3 gap-4 sm:gap-0 sm:items-end">
          {servicePackages.map((pkg, index) => {
            const isFeatured = pkg.featured;
            const isLeft = index === 0;
            const isRight = index === 2;

            return (
              <div
                key={pkg.id}
                className={`relative flex flex-col transition-all duration-300 cursor-default
                  ${isFeatured
                    ? 'rounded-3xl px-8 py-12 md:py-14 z-10 bg-charcoal shadow-[0_24px_80px_rgba(44,44,44,0.22)] order-first sm:order-none sm:-mx-1 sm:mt-0'
                    : 'bg-[#faf7f3] border border-blush px-7 py-9 hover:-translate-y-1 rounded-3xl sm:mt-10'
                  }
                  ${isLeft ? 'order-2 sm:order-none sm:rounded-l-3xl sm:rounded-r-none' : ''}
                  ${isRight ? 'order-3 sm:order-none sm:rounded-r-3xl sm:rounded-l-none' : ''}
                `}
              >
                {/* "Beliebteste Wahl" label */}
                {isFeatured && pkg.badge && (
                  <div className="absolute -top-4 left-1/2 -translate-x-1/2 whitespace-nowrap">
                    <span className="inline-flex items-center gap-1.5 bg-rose text-white font-sans text-xs font-semibold tracking-wide px-4 py-1.5 rounded-full shadow-sm">
                      <span className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className="ri-star-fill text-[10px]" />
                      </span>
                      {pkg.badge}
                    </span>
                  </div>
                )}

                {/* Small tier label for outer cards */}
                {!isFeatured && pkg.badge && (
                  <span className="self-start font-sans text-[10px] tracking-widest uppercase font-semibold px-3 py-1 rounded-full mb-5 bg-blush text-rose-dark">
                    {pkg.badge}
                  </span>
                )}

                {/* Price — big and bold */}
                <div className={`flex items-end gap-1 mb-1 ${isFeatured ? 'mt-2' : ''}`}>
                  <span
                    className={`font-serif font-medium leading-none ${
                      isFeatured
                        ? 'text-7xl text-white'
                        : 'text-5xl text-charcoal/80'
                    }`}
                  >
                    {pkg.price}
                  </span>
                </div>

                {/* Duration pill */}
                <div className={`inline-flex items-center gap-1.5 mb-4 ${isFeatured ? 'mt-2' : 'mt-1.5'}`}>
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-time-line text-rose text-sm" />
                  </span>
                  <span className={`font-sans text-sm ${isFeatured ? 'text-white/55' : 'text-charcoal/45'}`}>
                    {pkg.duration}
                  </span>
                </div>

                {/* Name */}
                <h3
                  className={`font-sans font-semibold mb-3 ${
                    isFeatured ? 'text-xl text-white' : 'text-base text-charcoal'
                  }`}
                >
                  {pkg.name}
                </h3>

                {/* Divider */}
                <div className={`w-10 h-px mb-4 ${isFeatured ? 'bg-rose/50' : 'bg-blush'}`} />

                {/* Description */}
                <p
                  className={`font-sans leading-relaxed flex-1 mb-8 ${
                    isFeatured ? 'text-sm text-white/65' : 'text-sm text-charcoal/55'
                  }`}
                >
                  {pkg.description}
                </p>

                {/* CTA */}
                {isFeatured ? (
                  <Link
                    to="/leistungen"
                    className="inline-flex items-center justify-center gap-2 bg-rose hover:bg-rose-dark text-white font-sans text-sm font-medium px-6 py-3.5 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
                  >
                    Jetzt buchen
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-line text-sm" />
                    </span>
                  </Link>
                ) : (
                  <Link
                    to="/leistungen"
                    className="inline-flex items-center gap-1.5 font-sans text-sm font-medium text-rose hover:text-rose-dark transition-colors duration-200 cursor-pointer group"
                  >
                    Mehr erfahren
                    <span className="w-4 h-4 flex items-center justify-center transition-transform duration-200 group-hover:translate-x-1">
                      <i className="ri-arrow-right-line text-sm" />
                    </span>
                  </Link>
                )}
              </div>
            );
          })}
        </div>

        {/* All services link */}
        <div className="text-center mt-14">
          <Link
            to="/leistungen"
            className="inline-flex items-center gap-2 border border-charcoal text-charcoal hover:bg-charcoal/5 font-sans text-sm font-medium px-7 py-3 rounded-full transition-all duration-200 cursor-pointer"
          >
            Alle Leistungen ansehen
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm" />
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}
